/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export var Permission = {
    AllPermissions: 'ALL_PERMISSIONS',
    CreateUser: 'CREATE_USER',
    ReadUser: 'READ_USER',
    UpdateUser: 'UPDATE_USER',
    DeleteUser: 'DELETE_USER',
    CreateOrganisation: 'CREATE_ORGANISATION',
    ReadOrganisation: 'READ_ORGANISATION',
    SwitchToOrganisation: 'SWITCH_TO_ORGANISATION',
    UpdateOrganisation: 'UPDATE_ORGANISATION',
    DeleteOrganisation: 'DELETE_ORGANISATION',
    AdministerOrganisation: 'ADMINISTER_ORGANISATION',
    AccessNetwork: 'ACCESS_NETWORK',
    CreateNetwork: 'CREATE_NETWORK',
    ReadNetwork: 'READ_NETWORK',
    UpdateNetwork: 'UPDATE_NETWORK',
    DeleteNetwork: 'DELETE_NETWORK',
    CreateLocation: 'CREATE_LOCATION',
    ReadLocation: 'READ_LOCATION',
    UpdateLocation: 'UPDATE_LOCATION',
    DeleteLocation: 'DELETE_LOCATION',
    CreatePlayer: 'CREATE_PLAYER',
    ConfirmPlayer: 'CONFIRM_PLAYER',
    ReadPlayer: 'READ_PLAYER',
    UpdatePlayer: 'UPDATE_PLAYER',
    DeletePlayer: 'DELETE_PLAYER',
    CreateTag: 'CREATE_TAG',
    ReadTag: 'READ_TAG',
    UpdateTag: 'UPDATE_TAG',
    DeleteTag: 'DELETE_TAG',
    CreateCampaign: 'CREATE_CAMPAIGN',
    ReadCampaign: 'READ_CAMPAIGN',
    UpdateCampaign: 'UPDATE_CAMPAIGN',
    DeleteCampaign: 'DELETE_CAMPAIGN',
    CreateContent: 'CREATE_CONTENT',
    ReadContent: 'READ_CONTENT',
    UpdateContent: 'UPDATE_CONTENT',
    DeleteContent: 'DELETE_CONTENT',
    ReleaseContent: 'RELEASE_CONTENT',
    CreateRole: 'CREATE_ROLE',
    ReadRole: 'READ_ROLE',
    UpdateRole: 'UPDATE_ROLE',
    DeleteRole: 'DELETE_ROLE',
    GrantAccess: 'GRANT_ACCESS',
    CreateAccessGrant: 'CREATE_ACCESS_GRANT',
    ReadAccessGrant: 'READ_ACCESS_GRANT',
    UpdateAccessGrant: 'UPDATE_ACCESS_GRANT',
    DeleteAccessGrant: 'DELETE_ACCESS_GRANT',
    ReadApiDocs: 'READ_API_DOCS'
};
export function PermissionFromJSON(json) {
    return PermissionFromJSONTyped(json, false);
}
export function PermissionFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function PermissionToJSON(value) {
    return value;
}
